import { render } from "./contactForm.vue?vue&type=template&id=5083ad60&scoped=true&ts=true"
import script from "./contactForm.vue?vue&type=script&lang=ts"
export * from "./contactForm.vue?vue&type=script&lang=ts"

import "./contactForm.vue?vue&type=style&index=0&id=5083ad60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5083ad60"]])

export default __exports__